/**
 * Initialise Sentry/GlitchTip in the browser.
 *
 * Reads REACT_APP_SENTRY_DSN at build time. When unset, init is a no-op
 * and the bundle still works — safe to deploy with or without observability.
 *
 *   REACT_APP_SENTRY_DSN=https://<key>@your-glitchtip-instance/<project_id>
 *   REACT_APP_SENTRY_ENVIRONMENT=production
 *   REACT_APP_SENTRY_RELEASE=<git-sha or tag>
 *
 * Cookie consent: errors are sent regardless (operational data, not
 * marketing). PII (cookies, auth header, body) is stripped in beforeSend.
 */
export function initErrorTracking() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  try {
    const Sentry = require('@sentry/react');
    Sentry.init({
      dsn,
      environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production',
      release:     process.env.REACT_APP_SENTRY_RELEASE     || undefined,
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0,    // session replay off by default — quota-friendly
      replaysOnErrorSampleRate: 0,
      sendDefaultPii: false,
      beforeSend(event) {
        // Belt-and-braces: strip auth + cookies if present.
        if (event.request?.headers) {
          delete event.request.headers.authorization;
          delete event.request.headers.cookie;
        }
        return event;
      },
    });
    // eslint-disable-next-line no-console
    console.log('Sentry/GlitchTip browser init OK');
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Sentry init failed:', err.message);
  }
}
